import { cipo } from 'cipo';
import { fabric } from 'fabric';

cipo.directive("fabricsignature", function (URI, userService, $http, Message) {
    return {
        restrict: "EA",
        scope: {
            "scale": "="
        },
        templateUrl: "/ng/views/directives/system/fabricsignature.html",
        link: function ($scope, element) {
            //svg.draw plugin
            (function () { function a(a, b, c) { this.el = a, a.remember("_paintHandler", this); var d = this, e = this.getPlugin(); this.parent = a.parent(SVG.Nested) || a.parent(SVG.Doc), this.p = this.parent.node.createSVGPoint(), this.m = null, this.startPoint = null, this.lastUpdateCall = null, this.options = {}; for (var f in this.el.draw.defaults) this.options[f] = this.el.draw.defaults[f], "undefined" != typeof c[f] && (this.options[f] = c[f]); e.point && (e.pointPlugin = e.point, delete e.point); for (var f in e) this[f] = e[f]; b || this.parent.on("click.draw", function (a) { d.start(a) }) } a.prototype.transformPoint = function (a, b) { return this.p.x = a - (this.offset.x - window.pageXOffset), this.p.y = b - (this.offset.y - window.pageYOffset), this.p.matrixTransform(this.m) }, a.prototype.start = function (a) { var b = this; this.m = this.el.node.getScreenCTM().inverse(), this.offset = { x: window.pageXOffset, y: window.pageYOffset }, this.options.snapToGrid *= Math.sqrt(this.m.a * this.m.a + this.m.b * this.m.b), this.startPoint = this.snapToGrid(this.transformPoint(a.clientX, a.clientY)), this.init && this.init(a), this.el.fire("drawstart", { event: a, p: this.p, m: this.m }), SVG.on(window, "mousemove.draw", function (a) { b.update(a) }), this.start = this.point }, a.prototype.point = function (a) { return this.point != this.start ? this.start(a) : this.pointPlugin ? this.pointPlugin(a) : void this.stop(a) }, a.prototype.stop = function (a) { a && this.update(a), this.clean && this.clean(), SVG.off(window, "mousemove.draw"), this.parent.off("click.draw"), this.el.forget("_paintHandler"), this.el.draw = function () { }, this.el.fire("drawstop") }, a.prototype.update = function (a) { !a && this.lastUpdateCall && (a = this.lastUpdateCall), this.lastUpdateCall = a, this.calc(a), this.el.fire("drawupdate", { event: a, p: this.p, m: this.m }) }, a.prototype.done = function () { this.calc(), this.stop(), this.el.fire("drawdone") }, a.prototype.cancel = function () { this.stop(), this.el.remove(), this.el.fire("drawcancel") }, a.prototype.snapToGrid = function (a) { var b = null; if (a.length) return b = [a[0] % this.options.snapToGrid, a[1] % this.options.snapToGrid], a[0] -= b[0] < this.options.snapToGrid / 2 ? b[0] : b[0] - this.options.snapToGrid, a[1] -= b[1] < this.options.snapToGrid / 2 ? b[1] : b[1] - this.options.snapToGrid, a; for (var c in a) b = a[c] % this.options.snapToGrid, a[c] -= (b < this.options.snapToGrid / 2 ? b : b - this.options.snapToGrid) + (0 > b ? this.options.snapToGrid : 0); return a }, a.prototype.param = function (a, b) { this.options[a] = null === b ? this.el.draw.defaults[a] : b, this.update() }, a.prototype.getPlugin = function () { return this.el.draw.plugins[this.el.type] }, SVG.extend(SVG.Element, { draw: function (b, c, d) { b instanceof Event || "string" == typeof b || (c = b, b = null); var e = this.remember("_paintHandler") || new a(this, b, c || {}); return b instanceof Event && e.start(b), e[b] && e[b](c, d), this } }), SVG.Element.prototype.draw.defaults = { snapToGrid: 1 }, SVG.Element.prototype.draw.extend = function (a, b) { var c = {}; "string" == typeof a ? c[a] = b : c = a; for (var d in c) { var e = d.trim().split(/\s+/); for (var f in e) SVG.Element.prototype.draw.plugins[e[f]] = c[d] } }, SVG.Element.prototype.draw.plugins = {}, SVG.Element.prototype.draw.extend("rect image", { init: function (a) { var b = this.startPoint; this.el.attr({ x: b.x, y: b.y, height: 0, width: 0 }) }, calc: function (a) { var b = { x: this.startPoint.x, y: this.startPoint.y }, c = this.transformPoint(a.clientX, a.clientY); b.width = c.x - b.x, b.height = c.y - b.y, this.snapToGrid(b), b.width < 0 && (b.x = b.x + b.width, b.width = -b.width), b.height < 0 && (b.y = b.y + b.height, b.height = -b.height), this.el.attr(b) } }), SVG.Element.prototype.draw.extend("line polyline polygon", { init: function (a) { this.set = new SVG.Set; var b = this.startPoint, c = [[b.x, b.y], [b.x, b.y]]; this.el.plot(c), this.drawCircles() }, calc: function (a) { var b = this.el.array().valueOf(); if (b.pop(), a) { var c = this.transformPoint(a.clientX, a.clientY); b.push(this.snapToGrid([c.x, c.y])) } this.el.plot(b) }, point: function (a) { if (this.el.type.indexOf("poly") > -1) { var b = this.transformPoint(a.clientX, a.clientY), c = this.el.array().valueOf(); return c.push(this.snapToGrid([b.x, b.y])), this.el.plot(c), this.drawCircles(), void this.el.fire("drawpoint", { event: a, p: { x: b.x, y: b.y }, m: this.m }) } this.stop(a) }, clean: function () { this.set.each(function () { this.remove() }), this.set.clear(), delete this.set }, drawCircles: function () { var a = this.el.array().valueOf(); this.set.each(function () { this.remove() }), this.set.clear(); for (var b = 0; b < a.length; ++b) { this.p.x = a[b][0], this.p.y = a[b][1]; var c = this.p.matrixTransform(this.parent.node.getScreenCTM().inverse().multiply(this.el.node.getScreenCTM())); this.set.add(this.parent.circle(5).stroke({ width: 1 }).fill("#ccc").center(c.x, c.y)) } } }), SVG.Element.prototype.draw.extend("circle", { init: function (a) { var b = this.startPoint; this.el.attr({ cx: b.x, cy: b.y, r: 1 }) }, calc: function (a) { var b = this.transformPoint(a.clientX, a.clientY), c = { cx: this.startPoint.x, cy: this.startPoint.y, r: Math.sqrt((b.x - this.startPoint.x) * (b.x - this.startPoint.x) + (b.y - this.startPoint.y) * (b.y - this.startPoint.y)) }; this.snapToGrid(c), this.el.attr(c) } }), SVG.Element.prototype.draw.extend("ellipse", { init: function (a) { var b = this.startPoint; this.el.attr({ cx: b.x, cy: b.y, rx: 1, ry: 1 }) }, calc: function (a) { var b = this.transformPoint(a.clientX, a.clientY), c = { cx: this.startPoint.x, cy: this.startPoint.y, rx: Math.abs(b.x - this.startPoint.x), ry: Math.abs(b.y - this.startPoint.y) }; this.snapToGrid(c), this.el.attr(c) } }) }).call(this);
            //BUG saves an empty base64 string if you just save
            $scope.fontSize = 20;

            try {
                $scope.existingSignature = userService.system.userdata.signature || {};
            }
            catch (e) {
                $scope.existingSignature = {};
            }

            $scope.clearSignature = function () {
                try {
                    var parent = document.getElementById("canvasContainerSign");
                    var img = document.getElementById("imgSRC");
                    parent.removeChild(img);
                } catch (e) {
                    //
                }

                if ($scope.svgParent) {
                    while ($scope.svgParent.firstChild && !$scope.svgParent.firstChild.remove());
                }

                var iptBox = document.getElementById("signInputBoxID");
                if (iptBox) {
                    iptBox.value = "";
                }

                $scope.textString = '';
                userSignature.SignatureText = null;
            }

            $scope.signature = {
                type: 1,
                isText: null
            };

            //init user signature object with existing values
            var userSignature = {
                Signature: $scope.existingSignature.signature,
                SignatureText: $scope.existingSignature.signatureText,
                Type: $scope.existingSignature.type,
                FontSize: $scope.existingSignature.fontSize
            }

            var sParent = document.getElementById("drawing");
            var draw = SVG().addTo(sParent);
            draw.node.id = "svg";
            draw.node.width.baseVal.valueAsString = "250px";
            draw.node.height.baseVal.valueAsString = "120px";
            $scope.svgParent = draw.node;
            $scope.svgParent.pointerEvents = "bounding-box";


            $scope.svgParent.addEventListener("mouseover", function () {
                document.getElementById("drawing").style.cursor = "crosshair";
            });
            $scope.svgParent.addEventListener("mouseout", function () {
                document.getElementById("drawing").style.cursor = "crosshair";
            });


            var shapes = [];
            var index = 0;
            var isTouch = false;

            var getDrawObject = function () {
                var option = {
                    stroke: "black",
                    'stroke-width': 2,
                    'fill': "none",
                    'linecap': 'round',
                    'linejoin': 'round'
                }
                return draw.polyline().attr(option);
            }

            draw.on('mousedown', function (event) {
                var shape = getDrawObject();
                shapes[index] = shape;
                shape.draw(event);
            });

            draw.on('touchstart', function (event) {
                var shape = getDrawObject();
                shapes[index] = shape;
                shape.draw(event.touches[0]);
                isTouch = true;
            });

            draw.on('mousemove', function (event) {
                if (shapes[index]) {
                    shapes[index].draw('point', event);
                }
            });
            draw.on('touchmove', function (event) {
                if (shapes[index]) {
                    shapes[index].draw('point', event.touches[0]);
                }
            });

            draw.on('touchend', function (event) {
                shapes[index].draw('stop', event.touches[0]);
                isTouch = false;
            });

            draw.on('mouseup', function (event) {
                shapes[index].draw('stop', event);
            });

            var mUpFunc = function (event) {
                try {
                    shapes[index].draw('stop', event);

                } catch (e) { }
            };
            //to catch mouse leave svg space
            document.getElementById("drawing").addEventListener('mouseleave', mUpFunc);


            // This is custom extension of line, polyline, polygon which doesn't draw the circle on the line. 
            SVG.Element.prototype.draw.extend('line polyline polygon', {

                init: function (e) {
                    // When we draw a polygon, we immediately need 2 points.
                    // One start-point and one point at the mouse-position

                    this.set = new SVG.List();

                    var p = this.startPoint;
                    var arr = [
                        [p.x, p.y],
                        [p.x, p.y]
                    ];


                    this.el.plot(arr);
                },

                // The calc-function sets the position of the last point to the mouse-position (with offset ofc)
                calc: function (e) {
                    var arr = this.el.array().valueOf();
                    arr.pop();

                    if (e) {
                        var p = this.transformPoint(e.clientX, e.clientY);
                        arr.push(this.snapToGrid([p.x, p.y]));
                    }

                    this.el.plot(arr);

                },

                point: function (e) {

                    if (this.el.type.indexOf('poly') > -1) {
                        // Add the new Point to the point-array
                        if (!isTouch) {
                            var p = this.transformPoint(e.clientX, e.clientY),
                                arr = this.el.array().valueOf();
                        }

                        else if (isTouch) {
                            var p = this.transformPoint(e.clientX, e.clientY),
                                arr = this.el.array().valueOf();
                        }

                        arr.push(this.snapToGrid([p.x, p.y]));

                        this.el.plot(arr);

                        // Fire the `drawpoint`-event, which holds the coords of the new Point
                        try {
                            this.el.fire('drawpoint', { event: e, p: { x: p.x, y: p.y }, m: this.m });
                        } catch (e) {
                            console.log(e);
                        }

                        return;
                    }

                    // We are done, if the element is no polyline or polygon
                    this.stop(e);

                },

                clean: function () {

                    // Remove all circles
                    this.set.each(function () {
                        this.remove();
                    });

                    this.set.clear();

                    delete this.set;

                },
            });

            $scope.highlightSignatureBtnDraw = function () {
                document.getElementById("fabricSignatureNameID").style.backgroundColor = null;
                var b = document.getElementById("fabricSignatureDrawID");
                b.style.backgroundColor = "#f7ad59";

                $scope.svgParent.style.visibility = "visible";
            };
            $scope.highlightSignatureBtnName = function () {
                document.getElementById("fabricSignatureDrawID").style.backgroundColor = null;
                var b = document.getElementById("fabricSignatureNameID");
                b.style.backgroundColor = "#f7ad59";
                $scope.svgParent.style.visibility = "hidden";
            }
            $scope.setSignWithName = function (value) {
                $scope.signWithName.value = value;
            }
            $scope.signWithName = {
                value: false
            };

            var signName = function (name, font, fontsize, load) {
                if (load != true) {
                    $scope.clearSignature();
                }

                $scope.svgParent.style.visibility = "visible";
                $scope.highlightSignatureBtnDraw();
                $scope.textString = name;
                $scope.fontSize = parseInt(fontsize.split("p")[0]);
            }

            //create img based from svg
            $scope.svgToBlob = function (ftsz) {
                var p = document.getElementById("signatureId");
                var canvas = new fabric.Canvas(p.getElementsByTagName('canvas')[0]);
                try {
                    if ($scope.signWithName.value) {
                        var textbox = new fabric.Text($scope.textString, {
                            left: 0,
                            top: 0,
                            fontSize: 112,
                            fontFamily: 'la_belle_auroreregular',
                        });

                        canvas.setWidth(textbox.width);
                        canvas.add(textbox);
                        canvas.renderAll();
                    }
                    else {
                        var poliLines = p.getElementsByTagName("polyline");
                            
                        canvas.setWidth(250);
                        canvas.setHeight(120);
    
                        for (var i = 0; i < poliLines.length; i++) {
                            var canvasPoints = [];
                            for (var j = 0; j < poliLines[i].points.length; j++) {
                                var point = {
                                    x: poliLines[i].points[j].x,
                                    y: poliLines[i].points[j].y
                                };
                                canvasPoints.push(point);
                            }

                            var poly = new fabric.Polyline(canvasPoints, {
                                stroke: 'black',
                                strokeWidth: 5,
                                fill: ''
                            });
                            canvas.add(poly);
                        }

                        canvas.renderAll();
                    }
                } catch (e) {
                    console.log(e);
                }
                
                $scope.base64Data = canvas.toDataURL({
                    format: 'png',
                }).split(",")[1];

                userSignature.Signature = $scope.base64Data;

            }

            $scope.scaleSignature = function (scale) {
                sParent.style.width = (scale * 250) + "px";
                sParent.style.height = (scale * 120) + "px";
                //scale, in svg js, scales from objects relative center
                var scale = parseFloat(scale);
                draw.scale(scale, -125, -60);
                draw.node.style.background = "#fffffff";
                document.getElementById("canvasContainerSign").style.width = (scale * 250) + "px";
                document.getElementById("canvasContainerSign").style.height = (scale * 120) + "px";
            };

            $scope.$watch(function () { return userService.system.userdata.signature; },
                function (n, o) {
                    $scope.loadSVG(userService.system.userdata.signature);
                    $scope.existingSignature = userService.system.userdata.signature;
            });

            //load signature or name in svg format
            $scope.loadSVG = function (signature) {
                if (signature) {
                    if (signature.type == 1) {
                        var allLines = signature.signatureText.split("/");
                        for (var i = 0; i < allLines.length - 1; i++) {// -1 because last string is always empty
                            var points = allLines[i].replace(/;/g, " ");
                            var line = draw.polyline(points.toString()).fill('none');
                            line.stroke({ color: 'black', width: 2, linecap: 'round', linejoin: 'round' })
                        }
                        $scope.signature.file = signature.signatureText;
                        $scope.signature.type = signature.type;
                        $scope.setSignWithName(false);
                        $scope.highlightSignatureBtnDraw()
                    }
                    else if (signature.type == 2) {
                        //resize text
                        try {

                            if (signature.signatureText.length > 0) {
                                var string = signature.signatureText;
                                if (string.length < 21) {
                                    var x = (parseInt(parseInt(string.length) / 5) + 1);
                                    var fontSize = 60 - (8 * x) + "px";
                                    $scope.fontSize = 60 - (8 * x)
                                }
                                else {
                                    var fontSize = "20px";
                                    $scope.fontSize = 20;
                                }
                                $scope.signature.file = signature.signatureText;
                                $scope.signature.type = signature.type;
                                signName(signature.signatureText, "", fontSize, true);
                                $scope.setSignWithName(true);
                                $scope.highlightSignatureBtnName()
                            }

                        } catch (e) {
                            console.log("No signature found");
                        }

                    }
                }
        };
            
            $scope.saveSignature = function () {
                $scope.newbase64File = null;
                userSignature.FontSize = $scope.fontSize + 20;
                if ($scope.isChecked == true) {
                    var inptBox = document.getElementById("signInputBoxID");

                    if ($scope.signWithName.value) {

                        signName(inptBox.value, inptBox.style.fontFamily, inptBox.style.fontSize, false);
                        userSignature.FontSize = $scope.fontSize + 20;
                        var iptBox = document.getElementById("signInputBoxID");
                        iptBox.style.display = "none";

                        userSignature.SignatureText = $scope.textString
                        userSignature.Type = 2;

                    }
                    else {
                        $scope.pointArrayString = "";//format type x,y;x,y;...;x,y/
                        for (var i = 0; i < $scope.svgParent.childNodes.length; i++){
                            if ($scope.svgParent.childNodes[i].tagName != "text") {                                
                                for (var j = 0; j < $scope.svgParent.childNodes[i].points.numberOfItems; j++) {
                                    var pointObj = $scope.svgParent.childNodes[i].points.getItem(j);
                                    $scope.pointArrayString += pointObj.x + "," + pointObj.y + ";";
                                }
                                $scope.pointArrayString += "/";
                            }
                            else {
                                Message.error("Can not have both name and drawn signature");
                                return;
                            }
                        }

                        userSignature.SignatureText = $scope.pointArrayString;
                        userSignature.Type = 1;
                    }
                    $scope.scaleSignature(8);
                    $scope.svgToBlob($scope.fontSize);
                    $http[URI.SYSTEM.CREATE_SIGNATURE.method](URI.SYSTEM.CREATE_SIGNATURE.toString(), userSignature)
                        .then(function () {
                            $scope.clearSignature();
                            userService.triggerUserRefresh();
                            Message.info('Signature updated successfully.');

                        })
                        .catch(function (e) {
                            Message.dberror(e);
                        })

                    var svgScaleDown = document.getElementById("svg");
                    svgScaleDown.setAttribute('transform', 'scale(1)');

                    var divScaleDown = document.getElementById("drawing");
                    divScaleDown.style.width = svgScaleDown.width.baseVal.value + "px";
                    divScaleDown.style.height = svgScaleDown.height.baseVal.value + "px";

                    var divWrapperScaleDown = document.getElementById("canvasContainerSign");
                    divWrapperScaleDown.style.width = svgScaleDown.width.baseVal.value + "px";
                    divWrapperScaleDown.style.height = svgScaleDown.height.baseVal.value + "px";
                    $scope.signWithName.value = false;                        
                }
                else {
                    Message.error("Please aggree to use this signature to electronically sign forms");
                }
            };

            var resizeText = function (inputBox) {
                var string = inputBox.value;
                if (string.length < 21) {
                    var x = (parseInt(parseInt(string.length) / 5) + 1);
                    inputBox.style.fontSize = 60 - (8 * x) + "px";
                }
                else {
                    inputBox.style.fontSize = "20px";
                }
            };

            //watch for inputed name
            $scope.$watch(function () { return $scope.signWithName.value },
                function (n, o) {
                    if ($scope.signWithName.value == true) {
                        //hide img if it exists
                        try {
                            var img = document.getElementById("imgSRC");
                            img.style.visibility = "hidden";
                        } catch (e) { }

                        var cont = document.getElementById("canvasContainerSign");
                        var inputBox = document.createElement("input");
                        inputBox.id = "signInputBoxID";
                        inputBox.type = "text";
                        inputBox.style.zIndex = 1;
                        inputBox.style.position = "absolute";
                        inputBox.style.width = "250px";
                        inputBox.style.height = "120px";
                        inputBox.style.fontSize = "60px";
                        inputBox.style.background = "transparent";
                        inputBox.autocomplete = "off";
                        inputBox.onchange = function (ev) {
                            $scope.textString = ev.target.value;
                        };
                        cont.insertBefore(inputBox, cont.childNodes[0]);
                        //diff for letter, caps or no caps
                        //max length 25
                        
                        if ($scope.textString) {
                            inputBox.value = $scope.textString;
                            resizeText(inputBox);
                        }
                        inputBox.addEventListener("keyup", function () {
                            resizeText(inputBox);
                        });
                    }
                    if ($scope.signWithName.value == false) {
                        try {
                            var iptBox = document.getElementById("signInputBoxID");
                            var cont = document.getElementById("canvasContainerSign");
                            cont.removeChild(iptBox);
                        }
                        catch (e) {
                            //console.log(e);
                        }
                    }
                });

            $scope.scaleSignature($scope.scale);
        }//
    }
});
